export default __webpack_public_path__ + "static/media/trus11.28a22843.png";